/**
 * Подпись единицы измерения у оси Y — одна форма на обе роли.
 *
 * ЗАЧЕМ ОБЩИЙ МОДУЛЬ. Карточки «Объём», «Самочувствие», «Форма» и «Нагрузка»
 * существуют И у атлета, И в тренерской админке — двумя независимыми копиями.
 * Подписи осей не было ни в одной; заводя её, легко завести двумя разными
 * способами, и тогда тренер с атлетом будут читать один и тот же график с
 * по-разному стоящим текстом. Расхождение мелкое, но именно такие живут
 * годами: их никто не считает багом.
 *
 * ПОЧЕМУ ЗДЕСЬ, А НЕ В КОМПОНЕНТЕ. Модуль чистый: ни React, ни DOM, ни i18n —
 * текст приходит уже переведённым. Возвращается обычный объект, который
 * recharts принимает в проп `label` у `<YAxis>`.
 *
 * ⚠️ ЭТО НЕ КОМПОНЕНТ И НЕ МОЖЕТ ИМ СТАТЬ. Recharts разбирает детей графика по
 * displayName и молча выбрасывает чужие обёртки — см.
 * `athlete/src/components/canon/rechartsChildDispatch.test.tsx`. Общее знание
 * об осях может ездить только пропсами.
 */

export type AxisSide = "left" | "right";

export interface AxisLabelSpec {
  value: string;
  angle: number;
  position: "insideLeft" | "insideRight";
  offset?: number;
  style: { fontSize: number; fill: string };
}

/**
 * Подпись оси.
 *
 * Справа текст поворачивается в другую сторону: при том же угле, что слева,
 * он читался бы вверх ногами.
 *
 * ОТСТУП НУЖЕН НЕ ВСЕГДА, НО КОГДА НУЖЕН — БЕЗ НЕГО ПОДПИСЬ ПРОПАДАЕТ.
 * Карточка с отрицательным `margin.left` (так экономят ширину на телефоне)
 * выносит подпись за пределы области, и recharts обрезает её до многоточия: на
 * кривой формы левая подпись превратилась в две точки, а правая («свежесть»)
 * встала вплотную к значениям −10 / −15. Дефолт оставлен нулевым, чтобы не
 * сдвинуть остальные оси — их свели к этой функции только в v210.
 *
 * @param value  уже переведённая единица («TSS/день», «мин», «уд/мин»)
 * @param side   сторона графика
 * @param offset сдвиг внутрь области данных, px
 */
export function axisLabel(
  value: string,
  side: AxisSide = "left",
  offset = 0,
): AxisLabelSpec {
  return {
    value,
    angle: side === "left" ? -90 : 90,
    position: side === "left" ? "insideLeft" : "insideRight",
    ...(offset ? { offset } : {}),
    style: { fontSize: 9, fill: "var(--fg-muted)" },
  };
}
